import { IconButton, InputAdornment, SxProps, TextField, Theme } from '@mui/material';
import intl from 'components/i18n/ReactIntlWrapper';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

export default function SearchInput({
  value,
  onChange,
  onClear,
  sx
}: {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  sx?: SxProps<Theme>
}) {
  return (
    <TextField
      label={intl.get('searchBar.placeholder')}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      sx={sx}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: onClear && (
            <InputAdornment position="end">
              <IconButton onClick={onClear} size="small">
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
}
